
import { RegisteredTypes } from '../../../service/emailDomainService';
import { getEmailParts } from './RegisteredEmailDomainInputContainer';

import type { RegisteredEmailsAndDomainsResponse } from '../../../service/emailDomainService';

const responseProcessor = (
  responseData: RegisteredEmailsAndDomainsResponse,
): { emailList: string[], domainList: string[] } => {
  const enabledAndVerifiedList = responseData.filter(item => item.isEnabled && item.isVerified);

  const emailList: string[] = [];
  const domainList: string[] = [];

  enabledAndVerifiedList.forEach(item => {
    if (item.type === RegisteredTypes.EMAIL_ADDRESS) {
      emailList.push(item.identity);
    } else if (item.type === RegisteredTypes.DOMAIN) {
      domainList.push(item.identity.toLowerCase());
    }
  });

  //clean email list (the weird function wrapper is because flow gets sassy about function methods' return types)
  const cleanedEmailList = emailList.filter(email => {
    const emailDomain = getEmailParts(email).domain;
    return emailDomain && !domainList.includes(emailDomain.toLowerCase());
  });

  return { emailList: cleanedEmailList, domainList };
};

export default responseProcessor;
